import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

import { applyRequestInterceptor } from './interceptors/request';
import { applyResponseInterceptor } from './interceptors/response';

interface APIConfig extends AxiosRequestConfig {
  useLoading?: boolean;
  useToken?: boolean;
  useErrorToast?: boolean;
  useRedirectAndLogout?: boolean;
}

const initConfig = {
  useLoading: true,
  useToken: true,
  useData: true,
  useErrorToast: true,
  // 404 에러시 main redirecting 시키지 않을 api config url
  useRedirectAndLogout: false,
  usePublicAPI: false,
  useHeadersData: false,
};

const createAPIInstance = (config: APIConfig = initConfig, auth: any, cookieDomain: string): AxiosInstance => {
  if (!config.baseURL) {
    throw new Error('Base URL is required to create an API instance.');
  }

  const instance = axios.create({
    ...initConfig,
    ...config,
  });

  applyRequestInterceptor(instance, config, auth, cookieDomain);
  applyResponseInterceptor(instance, config, auth);

  return instance;
};

export { createAPIInstance };
